import React, { memo, useState, useEffect } from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  Button,
  Divider,
  Collapse,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  ButtonBase,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "react-bootstrap/Accordion";
import { useAuth } from "../../auth/AuthContext";

const AssessmentList = ({ assessments, submitAssessment, student = {} }) => {
  const [expanded, setExpanded] = useState({});
  const [previewExpanded, setPreviewExpanded] = useState({});
  const [assAttempt, setAssAttempt] = useState({});
  const [assAttemptAnswers, setAssAttemptAnswers] = useState({});
  const [userAnswers, setUserAnswers] = useState({
    assessment_ID: "",
    student_ID: "",
    attempt: [],
  });
  const { getData } = useAuth();
  const [selectedAss, setSelectedAss] = useState({});

  useEffect(() => {
    const fetchAttempt = async () => {
      try {
        const response = await getData("proccess.php", "gradings_V2");
        let attempt = null;
        if (response.success) {
          if (selectedAss && response.data.length > 0) {
            attempt = response.data.find(
              (att) => att.assessment_ID === selectedAss.id && att.student_ID === student.id
            );
            setAssAttempt(attempt || {});
          } else {
            setAssAttempt({});
          }
        } else {
          console.log(response.message);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchAttempt();
  }, [selectedAss, getData, student.id]);

  useEffect(() => {
    const fetchAttempt = async () => {
      try {
        const responseAss = await getData("proccess.php", "assess_attempt_V2");
        let attempt = null;

        if (responseAss.success) {
          if (selectedAss && responseAss.data.length > 0) {
            attempt = responseAss.data.find(
              (att) => att.assessment_ID === selectedAss.id && att.student_ID === student.id
            );
            setAssAttemptAnswers(attempt || {});
          } else {
            setAssAttemptAnswers({});
          }
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchAttempt();
  }, [selectedAss, getData, student.id]);

  const percentage = (score = 0, weight = 100) => {
    const percent = (score / weight) * 100;
    return <Typography>{percent}%</Typography>;
  };

  const handleExpand = (id) => {
    setExpanded((prev) => {
      const isExpanding = !prev[id];
      const newExpanded = { ...prev, [id]: isExpanding };

      if (isExpanding) {
        const assessment = assessments.find((a) => a.id === id);
        if (assessment) {
          const initialAttempt = assessment.questions.map((q) => ({
            question: q.question,
            answers: "",
            question_type: q.question_type,
          }));
          setUserAnswers({
            assessment_ID: id,
            student_ID: student.id,
            attempt: initialAttempt,
          });
        }
      }

      return newExpanded;
    });
  };

  const handlePreviewExpand = (id) => {
    setPreviewExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handleAnswerChange = (assessmentId, questionIndex, value) => {
    setUserAnswers((prev) => {
      if (questionIndex >= prev.attempt.length) {
        return prev; // Prevent out-of-bounds, though initialization should prevent this
      }
      return {
        ...prev,
        assessment_ID: assessmentId,
        student_ID: student.id,
        attempt: prev.attempt.map((item, index) =>
          index === questionIndex ? { ...item, answers: value } : item
        ),
      };
    });
  };

  const handleSubmit = (assessmentId) => {
  const attempt = userAnswers.attempt;
  if (attempt.every((a) => a.answers !== "")) {
    submitAssessment(assessmentId, attempt); // Send full attempt array
    setExpanded((prev) => ({ ...prev, [assessmentId]: false }));
    setUserAnswers({
      assessment_ID: "",
      student_ID: "",
      attempt: [],
    });
  } else {
    alert("Please answer all questions before submitting.");
  }
};

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle1" fontWeight="bold">
        Assessments
      </Typography>
      <Divider sx={{ my: 1 }} />
      {assessments.length > 0 ? (
        <List>
          {assessments.map((assessment) => (
            <ListItem
              key={assessment.id}
              sx={{ flexDirection: "column", alignItems: "flex-start", width: "100%" }}
            >
              <Accordion style={{ width: "100%" }} onClick={() => setSelectedAss(assessment)}>
                <Accordion.Item eventKey={assessment.id}>
                  <Accordion.Header>
                    {assessment.name || `Material ${assessment.id || "Unknown"}`}
                  </Accordion.Header>
                  <Accordion.Body>
                    <Box display="flex" flexWrap="wrap" justifyContent="center" gap={2}>
                      <Box
                        sx={{
                          flex: 1,
                          minWidth: "100px",
                          border: ".1rem solid gray",
                          borderRadius: ".3rem",
                          padding: ".5rem",
                        }}
                      >
                        <table>
                          <tr>
                            <td>
                              <Typography>
                                <strong>
                                  {student.firstName} {student.lastName}
                                </strong>
                              </Typography>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <Typography>
                                <strong>Graded By: </strong>
                                {assAttempt.graded_by ? assAttempt.graded_by : "SYSTEM"}
                              </Typography>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <Box display="flex" justifyContent="space-between">
                                <Typography>
                                  <strong>Grade: </strong>
                                  {assAttempt.score ? assAttempt.score : "0"} /
                                  <span>{selectedAss.weight}</span>
                                </Typography>
                                <Box>
                                  {percentage(
                                    assAttempt.score ? assAttempt.score : 0,
                                    selectedAss.weight ? selectedAss.weight : 100
                                  )}
                                </Box>
                              </Box>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <Typography
                                sx={{
                                  padding: "1rem",
                                  borderRadius: ".3rem",
                                  color: "#fff",
                                  backgroundColor:
                                    assAttempt.student_ID === student.id ? "#1d9664" : "#f77e05",
                                }}
                              >
                                {assAttempt.student_ID === student.id
                                  ? "You have successfully attempted this quiz."
                                  : "You did not attempt this quiz yet."}
                              </Typography>
                            </td>
                          </tr>
                        </table>
                      </Box>
                      <Box
                        sx={{
                          flex: 1,
                          minWidth: "100px",
                          border: ".1rem solid gray",
                          borderRadius: ".3rem",
                          padding: ".5rem",
                        }}
                      >
                        <Typography variant="subtitle2">
                          {assessment.name || "Unnamed Assessment"} (Assessment #
                          {assessment.assess_number || "N/A"})
                        </Typography>
                        <Typography variant="body2">
                          <strong>Weight:</strong>{" "}
                          {assessment.weight != null ? `${assessment.weight}%` : "N/A"}
                        </Typography>
                        <Typography variant="body2">
                          <strong>Start Date:</strong>{" "}
                          {assessment.start_date
                            ? new Date(assessment.start_date).toLocaleString()
                            : "N/A"}
                        </Typography>
                        <Typography variant="body2">
                          <strong>Due Date:</strong>{" "}
                          {assessment.end_date
                            ? new Date(assessment.end_date).toLocaleString()
                            : "N/A"}
                        </Typography>
                      </Box>
                    </Box>
                    <Typography sx={{ padding: "1rem", margin: "1rem" }}>
                      {selectedAss.description}
                    </Typography>
                    {selectedAss.image !== "null" && (
                      <ButtonBase>
                        <Typography>Download {selectedAss.name} Document</Typography>
                      </ButtonBase>
                    )}
                    {assAttempt.student_ID === student.id ? (
                      <Button
                        variant="contained"
                        color="primary"
                        sx={{ mt: 1 }}
                        endIcon={<ExpandMoreIcon />}
                        onClick={() => handlePreviewExpand(assessment.id)}
                      >
                        {previewExpanded[assessment.id] ? "Hide Preview" : "Preview Assessment"}
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        color="primary"
                        sx={{ mt: 1 }}
                        endIcon={<ExpandMoreIcon />}
                        onClick={() => handleExpand(assessment.id)}
                      >
                        {expanded[assessment.id] ? "Hide" : "Attempt"} Assessment
                      </Button>
                    )}
                    {/* Preview Section */}
                    <Collapse in={previewExpanded[assessment.id]}>
                      <Box
                        sx={{
                          mt: 2,
                          width: "100%",
                          backgroundColor: "#f2f3f3ff",
                          padding: "1rem",
                        }}
                        display="flex"
                        flexDirection="column"
                      >
                        {Array.isArray(assessment.questions) && assessment.questions.length > 0 ? (
                          assessment.questions.map((question, index) => (
                            <Box key={index} sx={{ mb: 2 }}>
                              {console.log(assAttemptAnswers.attempt)}
                              <FormControl component="fieldset" sx={{ mb: 2 }}>
                                {question.question_type === "structured" ? (
                                  <Box>
                                    <Typography variant="body1">
                                      {question.question || "No question text"}
                                    </Typography>
                                    <div style={{ width: "100%" }}>
                                      <TextField
                                        style={{ width: "100%" }}
                                        multiline
                                        rows={4}
                                        value={assAttemptAnswers.attempt?.[index]?.answers || ""}
                                        disabled
                                        placeholder="No answer provided"
                                      />
                                    </div>
                                  </Box>
                                ) : (
                                  <Box>
                                    <Typography>{question.question}</Typography>
                                    <RadioGroup
                                      value={assAttemptAnswers.attempt?.[index]?.answers || ""}
                                      disabled
                                    >
                                      {question.answers.map((option, optIndex) => (
                                        <FormControlLabel
                                          key={optIndex}
                                          value={option}
                                          control={<Radio disabled />}
                                          label={option || "No option text"}
                                        />
                                      ))}
                                    </RadioGroup>
                                  </Box>
                                )}
                              </FormControl>
                              <Typography
                                sx={{
                                  p: 1,
                                  borderRadius: "0.3rem",
                                  color: question.question_type === "structured" ? "#000000ff" : "#fff",
                                  backgroundColor:
                                    question.question_type === "structured"
                                      ? "#bae1e6ff"
                                      : assAttemptAnswers.attempt?.[index]?.answers === question.correct_answer
                                      ? "#1d9664" // Success background
                                      : "#ff2600ff", // Warning background
                                }}
                              >
                                {question.question_type === "structured"
                                  ? "To be reviewed"
                                  : assAttemptAnswers.attempt?.[index]?.answers === question.correct_answer
                                  ? `Your answer is correct. The correct answer is: ${question.correct_answer || "N/A"}`
                                  : `Your answer is incorrect. The correct answer is: ${question.correct_answer || "N/A"}`}
                              </Typography>
                            </Box>
                          ))
                        ) : (
                          <Typography>No questions available for this assessment.</Typography>
                        )}
                      </Box>
                    </Collapse>
                    {/* Attempt Section */}
                    <Collapse in={expanded[assessment.id]}>
                      <Box
                        sx={{
                          mt: 2,
                          width: "100%",
                          backgroundColor: "#c6ebf7",
                          padding: "1rem",
                        }}
                        display="flex"
                        flexDirection="column"
                      >
                        {Array.isArray(assessment.questions) && assessment.questions.length > 0 ? (
                          assessment.questions.map((question, index) => (
                            <FormControl key={index} component="fieldset" sx={{ mb: 2 }}>
                              {question.question_type === "structured" ? (
                                <Box>
                                  <Typography variant="body1">
                                    {question.question || "No question text"}
                                  </Typography>
                                  <div style={{ width: "100%" }}>
                                    <TextField
                                      style={{ width: "100%" }}
                                      multiline
                                      rows={4}
                                      value={userAnswers.attempt[index]?.answers || ""}
                                      onChange={(e) =>
                                        handleAnswerChange(assessment.id, index, e.target.value)
                                      }
                                      placeholder="Enter your answer"
                                    />
                                  </div>
                                </Box>
                              ) : (
                                <Box>
                                  <Typography>{question.question}</Typography>
                                  <RadioGroup
                                    value={userAnswers.attempt[index]?.answers || ""}
                                    onChange={(e) =>
                                      handleAnswerChange(assessment.id, index, e.target.value)
                                    }
                                  >
                                    {question.answers.map((option, optIndex) => (
                                      <FormControlLabel
                                        key={optIndex}
                                        value={option}
                                        control={<Radio />}
                                        label={option || "No option text"}
                                      />
                                    ))}
                                  </RadioGroup>
                                </Box>
                              )}
                            </FormControl>
                          ))
                        ) : (
                          <Typography>No questions available for this assessment.</Typography>
                        )}
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={() => handleSubmit(assessment.id)}
                          disabled={!Array.isArray(assessment.questions) || assessment.questions.length === 0}
                        >
                          Submit Assessment
                        </Button>
                      </Box>
                    </Collapse>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </ListItem>
          ))}
        </List>
      ) : (
        <Typography variant="body2">
          No active assessments available for this module.
        </Typography>
      )}
    </Box>
  );
};

export default memo(AssessmentList);